/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Advanced_Options_TitleInputs */

const en_audio_description_export_advanced_options_title = /** @type {(inputs: Audio_Description_Export_Advanced_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced Options`)
};

const fr_audio_description_export_advanced_options_title = /** @type {(inputs: Audio_Description_Export_Advanced_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options avancées`)
};

const de_audio_description_export_advanced_options_title = /** @type {(inputs: Audio_Description_Export_Advanced_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterte Optionen`)
};

const it_audio_description_export_advanced_options_title = /** @type {(inputs: Audio_Description_Export_Advanced_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni avanzate`)
};

const ru_audio_description_export_advanced_options_title = /** @type {(inputs: Audio_Description_Export_Advanced_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расширенные параметры`)
};

const es_audio_description_export_advanced_options_title = /** @type {(inputs: Audio_Description_Export_Advanced_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones avanzadas`)
};

const zh_cn2_audio_description_export_advanced_options_title = /** @type {(inputs: Audio_Description_Export_Advanced_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级选项`)
};

const ja_audio_description_export_advanced_options_title = /** @type {(inputs: Audio_Description_Export_Advanced_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細オプション`)
};

const hi_audio_description_export_advanced_options_title = /** @type {(inputs: Audio_Description_Export_Advanced_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन्नत विकल्प`)
};

const pt_pt2_audio_description_export_advanced_options_title = /** @type {(inputs: Audio_Description_Export_Advanced_Options_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções avançadas`)
};

/**
* | output |
* | --- |
* | "Advanced Options" |
*
* @param {Audio_Description_Export_Advanced_Options_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_advanced_options_title = /** @type {((inputs?: Audio_Description_Export_Advanced_Options_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Advanced_Options_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_advanced_options_title(inputs)
	if (locale === "de") return de_audio_description_export_advanced_options_title(inputs)
	if (locale === "it") return it_audio_description_export_advanced_options_title(inputs)
	if (locale === "ru") return ru_audio_description_export_advanced_options_title(inputs)
	if (locale === "es") return es_audio_description_export_advanced_options_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_advanced_options_title(inputs)
	if (locale === "ja") return ja_audio_description_export_advanced_options_title(inputs)
	if (locale === "hi") return hi_audio_description_export_advanced_options_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_advanced_options_title(inputs)
	return en_audio_description_export_advanced_options_title(inputs)
});